import React from "react";
import GallerySlider from "../components/gallery/GallerySlider";
import { GalleryImages } from "../components/gallery/GalleryImages";

const Gallery = () => {
  return (
    <div id="gallery" className="flex justify-center text-white pt-2 pb-4">
      <div className="w-full bg-white text-[#2f1847] max-w-screen-lg pb-2">
        <div className="pb-2 px-3">
          <h1 className="text-4xl py-2">Gallery</h1>
          <p className="pb-2">
            This is a selection of my previous work, feel free to have a look
            around for inspiration.
          </p>
        </div>
        <div>
          <GallerySlider images={GalleryImages} />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
